module.exports = __webpack_public_path__ + "static/media/cd-icon-arrow.9b26ddf4.svg";